document.addEventListener('DOMContentLoaded', function () {
  if (mobileLoop != true && !mobileCover.includes('Liquid error')) {
    $('.homePageBanner .mobileImg').attr('src', mobileImg);
    setTimeout(() => {
      $('.homePageBanner .mobileImg').attr('src', mobileCover);
    }, mobileDefer * 1000);
  }
  $(`video.${clientWidth > 960 ? 'windowImg' : 'mobileImg'}`)[0].play();
});

// 优化后的触摸播放逻辑
document.addEventListener("touchstart", function(e) {
  // 精确获取视口宽度
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  
  // 根据屏幕尺寸选择对应视频
  const videoClass = viewportWidth > 960 ? 'windowImg' : 'mobileImg';
  const videoElement = document.querySelector(`.responsive-video.${videoClass}`);
  
  if(videoElement) {
    // 添加播放失败处理
    videoElement.play().catch(e => console.error("播放失败:", e));
  }
}, { passive: true }); // 推荐使用 passive 提升滚动性能


$(window).on('scroll', function () {
  $(`video.${clientWidth > 960 ? 'windowImg' : 'mobileImg'}`)[0].play();
})